<template>
  <section>
    <ul class="input-ul">
      <li><h3 class="subtitle mb-0">Trabajo</h3></li>
      <li>
        <div class="select">
          <select
            v-model="dataJobIn.option"
            @change="updateInput(dataJobIn.option)"
            width="100px"
            :disabled="disabled"
            :name="'selectOption'"
          >
            <option disabled value="">Seleccionar</option>
            <option value="opc-workDependency">En relación de dependencia</option>
            <option value="opc-adherente">Como particular (prepago)</option>
            <option value="opc-monotributista">Como monotributista</option>
          </select>
        </div>
      </li>
    </ul>




      <ul class="input-ul"  v-if="
           
            this.dataJobIn.option == 'opc-monotributista'
          ">
      <li><h3 class="subtitle mb-0">Categoría Monotributo</h3></li>
      <li>
        <div class="select">
          <select
            v-model="dataJobIn.categoria"
            required
            width="100px"
            :disabled="disabled"
            :name="'selectOption'"
          >
            <option disabled value="">Seleccionar</option>
            <option value="3">Monotributista Cat. A</option>
            <option value="3">Monotributista Cat. B </option>
            <option value="3">Monotributista Cat. C</option>
            <option value="4">Monotributista Cat. D</option>
            <option value="5">Monotributista Cat. E</option>
            <option value="6">Monotributista Cat. F</option>
            <option value="7">Monotributista Cat. G</option>
            <option value="8">Monotributista Cat. H</option>
            <option value="9">Monotributista Cat. I</option>
            <option value="10">Monotributista Cat. J</option>
            <option value="11">Monotributista Cat. K</option>
          </select>
        </div>
      </li>
    </ul>



      


    <template v-if="this.dataJobIn.option == 'opc-workDependency' && condition">
      <InputUl
        @change="personPartTimeChange"
        :inpType="'checkbox'"
        :inpName="'isPartTime'"
        :inpTitleStart="''"
        :inpTitleEnd="'¿Mi trabajo es de medio tiempo?'"
        :disabled="disabled"
      />
    </template>
  </section>
</template>

<script>
import InputUl from "./../form/InputUl";
export default {
  name: "JobIn",
  props: ["condition", "disabled"],
  components: { InputUl },
  data() {
    return {
      dataJobIn: {
        option: "",
        categoria: "",
        isPartTime: false,
      },
    };
  },
  methods: {
    personPartTimeChange(value) {
      this.dataJobIn.isPartTime = value;
    },
    updateInput(value) {
      this.dataJobIn.option = value;
      if (value !== "opc-workDependency") {
        this.dataJobIn.isPartTime = false;
      }
      this.$emit("change", this.dataJobIn);
    },
  },
};
</script>

<style scoped>
.input-ul {
  padding: 0;
  margin: 0;
  list-style: none;
  width: 100%;
  margin-bottom: 10px;
  display: inline-block;
  margin-right: 10px;
}
.input-ul li {
  display: inline-block;
  margin-right: 10px;
  vertical-align: middle;
}
.input-ul li:last-child {
  margin-right: 0;
}

input {
  background-color: transparent;
}

select {
  border-radius: 0;
  border: 0;
  color: #00738f;
  border-bottom: 3px solid #fbaf33;
}
.subtitle {
  color: #00738f;
  font-size: 24px;
  font-weight: bold;
}
.input-ul li:first-child,
.input-ul li:last-child {
  font-size: 24px;
  color: #00758f;
}
</style>
